/* Shared desktop navigation: preserve destination links; expose the directory by click or hover. */
(() => {
  const init = () => {
    document.querySelectorAll('header .mas-desktop-shop-menu').forEach(root => {
      if (root.dataset.masMenuReady) return;
      const trigger = root.querySelector(':scope > .hdt-categories-title');
      const menu = root.querySelector(':scope > .hdt-header-categories-flyout__menu');
      if (!trigger || !menu) return;
      const items = [...root.querySelectorAll('.hdt-header-categories-flyout__item')];
      const parents = items.filter(item => item.querySelector('.hdt-header-categories-flyout__panel'));
      let active = parents[0];
      let pinned = false;
      let closeTimer;
      const desktop = matchMedia('(min-width:1280px)');
      root.dataset.masMenuReady = 'true';
      root.classList.add('mas-menu-ready');
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', menu.id);
      trigger.removeAttribute('aria-haspopup');
      menu.inert = true;
      const place = () => {
        if (!desktop.matches) return;
        const r = root.getBoundingClientRect();
        const width = Math.min(1040, document.documentElement.clientWidth - 48);
        const left = Math.max(24, Math.min(r.left - 120, document.documentElement.clientWidth - width - 24));
        root.style.setProperty('--mas-menu-left', `${left - r.left}px`);
        root.style.setProperty('--mas-menu-notch', `${Math.min(width - 28, Math.max(28, r.left + r.width / 2 - left))}px`);
        const top = r.bottom + 14;
        root.style.setProperty('--mas-menu-max-height', `${Math.max(180, innerHeight - top - 20)}px`);
        const sidebar = root.querySelector('.mas-shop-sidebar');
        const panelContent = active?.querySelector('.hdt-header-categories-flyout__panel-inner');
        const sidebarHeight = sidebar ? sidebar.lastElementChild.getBoundingClientRect().bottom - sidebar.getBoundingClientRect().top + sidebar.scrollTop + parseFloat(getComputedStyle(sidebar).paddingBottom) : 0;
        root.style.setProperty('--mas-menu-content-height', `${Math.ceil(Math.max(384, sidebarHeight, panelContent?.scrollHeight || 0))}px`);
      };
      const select = item => {
        if (!item || !parents.includes(item)) return;
        active = item;
        parents.forEach(parent => {
          const selected = parent === active;
          parent.classList.toggle('is-active', selected);
          parent.querySelector('.hdt-header-categories-flyout__panel').inert = !selected;
          parent.querySelector('.mas-menu-group-toggle')?.setAttribute('aria-expanded', String(selected));
        });
      };
      const open = () => {
        if (!desktop.matches) return;
        clearTimeout(closeTimer);
        select(active); menu.inert = false;
        root.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true');
        place();
      };
      const close = (restoreFocus = false) => {
        clearTimeout(closeTimer); pinned = false;
        root.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); menu.inert = true;
        if (restoreFocus) trigger.focus({preventScroll:true});
      };
      trigger.addEventListener('click', event => {
        if (!desktop.matches || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (pinned && root.classList.contains('is-open')) close();
        else { pinned = true; open(); }
      });
      trigger.addEventListener('keydown', event => {
        if (event.key === ' ' || event.key === 'ArrowDown') {
          event.preventDefault(); pinned = true; open();
          if (event.key === 'ArrowDown') items[0].querySelector('.hdt-header-categories-flyout__link').focus();
        }
      });
      root.addEventListener('pointerenter', event => {if (event.pointerType !== 'touch') open();});
      root.addEventListener('pointerleave', () => {
        if (!pinned && !root.contains(document.activeElement)) closeTimer = setTimeout(close, 220);
      });
      parents.forEach(item => {
        item.addEventListener('pointerenter', event => {if (event.pointerType !== 'touch') {select(item); open();}});
        item.addEventListener('focusin', () => {select(item); open();});
      });
      root.addEventListener('focusout', () => {
        setTimeout(() => {if (!root.contains(document.activeElement) && !root.matches(':hover')) close();}, 0);
      });
      document.addEventListener('pointerdown', event => {if (!root.contains(event.target)) close();});
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && root.classList.contains('is-open')) {event.preventDefault();close(true);}
      });
      window.addEventListener('resize', () => {if (!desktop.matches) close();else if (root.classList.contains('is-open')) place();}, {passive:true});
      select(active); place();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

